export enum StatusInscription {
  inscrit = 1,
  present = 2,
  abscent = 3,  
  annulee = 4,  
  attente = 5
}
